import Vue, { PropType } from "vue";
import OS from "js/framework/utils/OS";

import styles from "../css/Popup.module.css";

interface IButtonConfig {
  label: string;
  onClick(): void;
  reversed?: boolean;
  disabled?: boolean;
}

export default Vue.extend({
  props: {
    buttons: Array as PropType<IButtonConfig[]>, 
  },
  render() {
    return (
      <div class={OS.desktop ? styles.buttonsWrapper : styles.buttonsWrapperMobile}>
        {this.buttons.map(({ label, onClick, disabled = false, reversed = false }) => {
          return (
            <button
              class={{
                [styles.button]: true,
                [styles.buttonReversed]: reversed,
                [styles.buttonDisabled]: disabled,
              }}
              onClick={!disabled ? onClick : () => {}}
            >
              { label }
            </button>
          );
        })}
      </div>
    );
  }
});
